/* Numbers and lists the landing page uses. test/unit/landing.test.ts checks them against the school seed, so the page
   can't drift from the data. */

/* supabase/seed/schools.sql: the universities students can search, and the countries they're in */
export const UNIVERSITIES = 2049;
export const COUNTRIES = 17;

/* the countries students can choose to study in on the landing page: the countries in the school seed */
export const DESTINATIONS = ['US', 'GB', 'CA', 'AU', 'DE', 'FR', 'NL', 'IE', 'NZ', 'SE', 'ES', 'IT', 'AE', 'JP', 'KR', 'MY', 'SG'];
